/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme } from 'bold-ui'
import { SideMenuSublink } from 'components/side-menu-navegation/SideMenuSublink'
import { useState } from 'react'
import { Accordion } from 'react-accessible-accordion'
import { useRouteMatch } from 'react-router'

import { AcompanhamentoMenuTitle, getAcompanhamentosSideMenuItems } from '../hooks/getAcompanhamentosSideMenuItems'
import { INFO_GESTACAO_URL } from '../pre-natal/AcompanhamentoPreNatalTabs'
import { AcompanhamentosSideMenuItem } from './AcompanhamentosSideMenuItem'

interface AcompanhamentosSideMenuProps {
  headerRef: React.RefObject<HTMLDivElement>
  isVisualizacaoProntuario: boolean
}

export function AcompanhamentosSideMenu(props: Readonly<AcompanhamentosSideMenuProps>) {
  const { headerRef, isVisualizacaoProntuario } = props
  const menuItems = getAcompanhamentosSideMenuItems()
  const initial = menuItems[0]?.title

  const [selectedMenu, setSelectedMenu] = useState<AcompanhamentoMenuTitle>(initial)

  const theme = useTheme()
  const styles = createStyles(theme)

  const match = useRouteMatch()
  const informacoesPath = `${match.url}/${INFO_GESTACAO_URL}`

  const handleMenuClick = (title: AcompanhamentoMenuTitle) => {
    title === selectedMenu ? setSelectedMenu(undefined) : setSelectedMenu(title)
  }

  const scrollWithOffset = (element: HTMLElement) => {
    const headerHeight = headerRef?.current.clientHeight
    const y = element.getBoundingClientRect().top + window.scrollY - (headerHeight || 0)
    const scroll = window.scrollY > headerHeight ? 'smooth' : 'auto'
    window.scrollTo({ behavior: scroll, top: y })
  }

  return (
    <aside css={styles.aside}>
      <Accordion allowZeroExpanded preExpanded={[selectedMenu]} css={css(styles.accordion)}>
        {menuItems.map((item) => (
          <AcompanhamentosSideMenuItem
            title={item.title}
            isMenuActive={selectedMenu === item.title}
            onClickMenuItem={() => handleMenuClick(item.title)}
            key={item.title}
            icon={item.icon}
            alt={item.alt}
            color={item.color}
          >
            {item.subItems.map((subItem) => (
              <SideMenuSublink
                scroll={!isVisualizacaoProntuario ? scrollWithOffset : undefined}
                to={`${informacoesPath}${subItem.to}`}
                key={subItem.title}
                title={subItem.title}
                sublinkStyle={css`
                  &.active {
                    color: ${item.color.c40};
                  }
                `}
              />
            ))}
          </AcompanhamentosSideMenuItem>
        ))}
      </Accordion>
    </aside>
  )
}

const createStyles = (theme: Theme) => ({
  aside: css`
    padding: 0;
    width: 100%;
    border: 0;
    height: auto;
    overflow: visible;
  `,

  accordion: css`
    border: 1px ${theme.pallete.gray.c60} solid;
  `,
})
